import { productToProcessSchema } from "@redotech/redo-return-core-common/returns/product-to-process-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const processReturn = {
  name: "processReturn" as const,
  input: z.object({
    returnId: zExt.objectId(),
    products: z.array(productToProcessSchema),
    customerRecoveryAmount: z.number(),
    options: z.object({
      sendNotifications: z.boolean(),
      refundInstantExchangeRecoveryFee: z.boolean(),
      waiveDraftFee: z.boolean().optional(),
      refundOriginalShipping: z.boolean().optional(),
      refundOriginalShippingAmount: z.number().optional(),
    }),
    customerNotes: z.string().optional(),
    customerImages: z.array(z.string()).optional(),
    restockLocationId: z.string().optional(),
    userId: zExt.objectId().optional(),
    orderTags: z.array(z.string()).optional(),
  }),
  output: z.object({ startedProcessing: z.boolean() }).nullish(),
};
